(ns hai.library.prompts.api
  "Prompt platform API events and subscriptions - code is quick, short and somewhat hardcoded,
  unlikely to be final form"
  (:require
   [hai.sharing.helper :as sharing]
   [hai.ui.rf-sugar :refer [defevent defevent-fx defsub]]
   [medley.core :refer [assoc-some]]))

(defn entity-route
  [entity]
  (let [uuid (sharing/->uuid entity)]
    (str "/assistant/v0/ai-prompts/" uuid)))

(def entity->api-route entity-route)

(defn- db->routed-uuid
  [db]
  (some-> (get-in db [:routing/current-route :path-params :ai-prompt/uuid])
          uuid))

(defevent-fx :assistant.prompt/update
  [{:keys [db]} {:keys [prompt on-success]}]
  (let [{:ai-prompt/keys [title content uuid]} prompt]
    {:fetch (assoc-some
             {:url (entity->api-route prompt)
              :body {:title title
                     :content content
                     :uuid uuid}
              :method :put}
             :on-success-fx on-success)}))

(defevent-fx :assistant.prompt/delete
  [{:keys [db]} {:keys [prompt on-success]}]
  {:fetch (assoc-some
           {:url (entity->api-route prompt)
            :method :delete}
           :on-success-fx on-success)})
